import { createSlice } from '@reduxjs/toolkit';
import { findElementById } from './TemplateJsonSlice';
import templateJsonStore from './TemplateJsonStore';

const initialState = {
  targetId: null,
  item: null,
};

const templateSelectedRootSlice = createSlice({
  name: 'templateSelectedRoot',
  initialState,
  reducers: {
    selectRoot: (state, action) => {
      state.targetId = action.payload;
      state.item = findElementById(templateJsonStore.getState().templateJson, state.targetId);
    },
    reSelectRoot: (state) => {
      if (state.targetId) {
        state.item = findElementById(templateJsonStore.getState().templateJson, state.targetId);
      }
    },
    resetRoot: (state) => {
      const app = templateJsonStore.getState().templateJson.templates[0];
      state.item = app;
      state.targetId = app.id;
    }
  },
});

export const { selectRoot, reSelectRoot, resetRoot } = templateSelectedRootSlice.actions;
export default templateSelectedRootSlice.reducer;
